import { Link } from 'react-router-dom';
import styles from './ProductCard.module.scss';
import { Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { useToggle } from '../../../utils/hooks/useToggle';
import useApiPrivate from '../../../utils/hooks/useApiPrivate';
import { useContext, useEffect, useState, useRef } from 'react';
import { UserContext } from '../../../globalContext/context';
import { showMsg } from '../../../langs/langs';
import { Toast } from 'primereact/toast';

const PRODUCT_URL = 'api/v1/products/';

export default function ProductCard(props) {
  const { data } = props;
  const apiPrivate = useApiPrivate();
  const {lang} = useContext(UserContext);
  const toast = useRef(null);

  const [modal, setModal, toggleModal] = useToggle(false);

  const [status, setStatus] = useState(data.status);
  const [isLoading, setIsLoading] = useState(false);
  const [badgeColor, setBadgeColor] = useState();

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

  const handleDeleteClick = async (id) => {
    setIsLoading(true)
    await apiPrivate.put(`${PRODUCT_URL}${id}/close`)
      .then(function(response){
        toggleModal();
        setIsLoading(false)
        showSuccess(`Product ${data.title} was closed successfully`);
        setTimeout(() => {
          props.callProducts();
        }, 2000);
      })
      .catch(function(error){
        setIsLoading(false)
        showError('Failed');
      })
    }

    useEffect(() => {
      if(status == 'PENDING'){
        setBadgeColor('warning');
      }
      if(status == 'APPROVE') {
        setBadgeColor('success');
      }
      if(status == 'REJECT') {
        setBadgeColor('danger');
      }
      if(status == 'SOLD') {
        setBadgeColor('light');
      }
      if(status == 'CLOSED') {
        setBadgeColor('dark');
      }
      if(status == 'EXPIRED') {
        setBadgeColor('danger');
      }
    },[status]);
    
    return (

    <>
      <Toast ref={toast} position="top-center" />

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader>
          {showMsg('close', lang)}:{' '}{data.title}
        </ModalHeader>
        <ModalBody>
          {showMsg('are_you_sure_you_want_to_close_product', lang)} 
            <span className='fw-bold'>
              {' '}{data.title}
            </span>?
             {showMsg('if_you_click_yes,_the_product_will_be_closed_forever', lang)}
        </ModalBody>
        <ModalFooter>
            <Button 
              color="danger" 
              onClick={() => handleDeleteClick(data.id)}
              disabled={isLoading && true}
              >
            {
              isLoading 
                ? (
                  <>
                    <Spinner size="sm">
                      Loading...
                    </Spinner>
                    <span>
                      {' '}Loading
                    </span>
                  </>
                )
                : showMsg('yes', lang)
            }
            </Button>{' '}
            <Button color="secondary" onClick={toggleModal}>
              {showMsg('cancel', lang)}
            </Button>
        </ModalFooter>
      </Modal>
      <div className={`${styles.productItem} text-body d-grid p-2`} id={data.id}>
        <Link 
          to={`/product/${data.id}`} 
          className={`text-decoration-none text-body ${styles.productImage} position-relative`}>
          <Badge 
            className={`position-absolute ${badgeColor == 'light' && "text-dark"} customBadge smallBadge smallBadgePos`} 
            color={badgeColor}
          >
            {status}
          </Badge>
          <img 
            src={`${!data.image ? '/images.png' : `${process.env.REACT_APP_API_URL}${data.image}`}`}
            className={`img-fluid ${styles.coverImage}`}
            />
        </Link>
        <div className={`d-grid ms-2 ${styles.content}`}>
          <div>
            <Link to={`/product/${data.id}`} className={`${styles.title} text-decoration-none text-body mb-2`}>
              {data.title}
            </Link>
            <div className={`${styles.priceBox}`}>
              <div className={` ${styles.price}`}>
                {'$'}{
                  data.discount > 0 ? data.discount_price : data.price
                }
              </div>
              {
                data.discount > 0 && 
                  <div className={`text-decoration-line-through`}>
                      {'$'}{data.price}
                  </div>
              }
            </div>
          </div>
          <div className={`ms-2 ${styles.actions} d-flex flex-column align-items-end justify-content-center`}>
            <div>
              {
                status === 'PENDING' 
                  ?(
                    <Link 
                      to={`/dashboard/edit-product/${data.id}`}
                      className={`btn btn-secondary btn-sm  mb-2`} 
                      size='sm'>
                      <i className="bi bi-pencil-square me-2 text-tertiary"></i>
                      <span>
                        {showMsg('edit', lang)}
                      </span>
                    </Link>
                  ) 
                  : (
                    <Link 
                      to={`/product/${data.id}`}
                      className={`btn btn-secondary btn-sm  mb-2 ${status === 'REJECT' && styles.disabledLink}`} 
                      size='sm'
                    >
                      <i className="bi bi-eye me-2 text-tertiary"></i>
                      <span>
                        {showMsg('view', lang)}
                      </span>
                    </Link>
                  )
              }
            </div>
            <div>
              <Button 
                onClick={toggleModal} 
                disabled = {status === 'CLOSED' ? true : false}
                size='sm'>
                <i className="bi bi-x-lg me-2 text-danger"></i> 
                <span>
                  {status === 'CLOSED' ? 'Closed' : 'Close'}
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
